
import React, { useState } from 'react';
import { DONATION } from '../data/config';

// ── DONATION SECTION ──────────────────────────────────────────
// Configure payment links and Venmo handle in src/data/config.js
// Venmo is currently the only payment option.

export default function Donate() {
  const [copied, setCopied] = useState(false);

  const copyVenmo = () => {
    navigator.clipboard.writeText(DONATION.venmoHandle).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const openVenmo = () => {
    const handle = DONATION.venmoHandle.replace('@', '');
    const note = encodeURIComponent('SHPE@VT Donation');
    const url = `https://venmo.com/${handle}?txn=pay&note=${note}`;
    window.open(url, '_blank');
  };

  return (
    <section
      id="donate"
      style={{ padding: '80px 24px', background: '#FFF3E8' }}
    >
      <div style={{ maxWidth: 900, margin: '0 auto' }}>

        <div className="section-header">
          <span className="section-label">Support SHPE@VT</span>
          <h2 className="section-title">Make a Contribution</h2>
          <p className="section-subtitle">
            {DONATION.campaignDescription}
          </p>
        </div>

        <div
          style={{
            background: 'white',
            borderRadius: 24,
            boxShadow: '0 8px 40px rgba(0,0,0,0.10)',
            overflow: 'hidden',
          }}
        >
          {/* Header banner */}
          <div
            style={{
              background: 'linear-gradient(135deg, #E5751F 0%, #C8922A 100%)',
              padding: '32px 40px',
              color: 'white',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 16,
              }}
            >
              <div>
                <h3
                  style={{
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 26,
                    fontWeight: 900,
                    marginBottom: 6,
                  }}
                >
                  Every Dollar Counts
                </h3>
                <p
                  style={{
                    color: 'rgba(255,255,255,0.85)',
                    fontSize: 14,
                  }}
                >
                  Donations fund conferences, outreach events, and scholarships.
                </p>
              </div>

              <div
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: 12,
                  padding: '12px 20px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                    opacity: 0.8,
                  }}
                >
                  Accepting
                </div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 15,
                    marginTop: 2,
                  }}
                >
                  Venmo
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: '40px' }}>

            {/* Payment options — Venmo only */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>

              {/* Venmo */}
              <div
                style={{
                  border: '2px solid #3D95CE',
                  borderRadius: 14,
                  overflow: 'hidden',
                  width: '100%',
                  maxWidth: 320,
                }}
              >
                <div
                  style={{
                    background: '#3D95CE',
                    padding: '14px 20px',
                    color: 'white',
                  }}
                >
                  <div style={{ fontWeight: 800, fontSize: 18 }}>
                    Venmo
                  </div>
                </div>

                <div style={{ padding: '20px' }}>

                  {/* Venmo handle and copy button */}
                  <div
                    style={{
                      background: '#EFF7FF',
                      borderRadius: 8,
                      padding: '10px 14px',
                      fontFamily: 'monospace',
                      fontSize: 15,
                      fontWeight: 700,
                      color: '#3D95CE',
                      marginBottom: 12,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {DONATION.venmoHandle}

                    <button
                      onClick={copyVenmo}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#3D95CE',
                        fontSize: 13,
                        fontFamily: 'inherit',
                        fontWeight: 600,
                      }}
                    >
                      {copied ? '✓ Copied!' : 'Copy'}
                    </button>
                  </div>

                  {/* Open Venmo */}
                  <button
                    onClick={openVenmo}
                    style={{
                      width: '100%',
                      padding: '11px',
                      borderRadius: 8,
                      background: '#3D95CE',
                      color: 'white',
                      border: 'none',
                      fontWeight: 700,
                      fontSize: 14,
                      cursor: 'pointer',
                      transition: 'background 0.2s',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.background = '#2B7AB0';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = '#3D95CE';
                    }}
                  >
                    Open Venmo →
                  </button>
                </div>
              </div>
            </div>

            {/* Disclaimer */}
            <p
              style={{
                textAlign: 'center',
                marginTop: 28,
                fontSize: 12,
                color: '#AAA',
                lineHeight: 1.6,
              }}
            >
              SHPE@VT is a registered student organization at Virginia Tech.
              Donations support chapter operations and are not tax-deductible.
              For questions, contact{' '}
              <a
                href="mailto:shpevt@gmail.com"
                style={{ color: '#E5751F' }}
              >
                shpevt@gmail.com
              </a>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
